import * as siteActions from '@lib/actions/SiteAction';
import { addTranslateToProps, ITranslationProps } from '@lib/i18n/translation';
import User from '@lib/pages/User';
import { ISite, IStoreSiteState, IUser } from '@lib/types/index';
import { connect, Dispatch } from 'react-redux';



export function mapStateToProps(state: any): IUserProps {
  const siteState: IStoreSiteState = state.site;
  return addTranslateToProps({
    site: siteState.site,
    syncing: siteState.syncing,
    user: siteState.user,
  })
}

export function mapDispatchToProps(dispatch: Dispatch<any>) {
  return {
    onGoBack: () => dispatch(siteActions.navigateToDashboard()),
  }
}

interface IUserProps extends ITranslationProps {
  user: IUser[];
  site: ISite;
  syncing: boolean;
}

interface IUserDispatchProps {
  onGoBack(): void;
}

export type UserProps = IUserProps & IUserDispatchProps;

export default connect<IUserProps, IUserDispatchProps, any>(mapStateToProps, mapDispatchToProps)(User);


// WEBPACK FOOTER //
// ./src/containers/User.tsx